<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="isLoggedIn"
      color="#EEEEEE"
      v-model="drawer"
      clipped
      app
      disable-resize-watcher
    >
      <v-list dense>
        <v-list-item two-line v-if="isLoggedIn" class="mb-2">
          <v-list-item-avatar>
            <v-icon x-large>mdi-account</v-icon>
          </v-list-item-avatar>

          <v-list-item-content class="mt-3">
            <v-list-item-title>{{ currentUser.name }}</v-list-item-title>
            <v-list-item-subtitle>Usario en Sesión</v-list-item-subtitle>
            <div align="right" class="mt-1">
              <v-btn x-small color="primary" dark to="/perfil">Mi perfil</v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-group
        v-if="roleUser === 1 || roleUser === 2"
          prepend-icon="mdi-list"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title>Catálogos</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in suparAdminCatalogo"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="roleUser === 3"
          prepend-icon="mdi-list"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title>Catálogos</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in oficialiaCatalogo"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="roleUser === 4"
          prepend-icon="mdi-list"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title>Catálogos</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in adminCatalogo"
            :key="i"
            link
            :to="menu.link"
          >

            <v-list-item-title v-text="menu.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>

          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="roleUser === 5"
          prepend-icon="mdi-list"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title>Catálogos</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in notificadorCatalogo"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <!-- <v-divider class="mb-3"></v-divider> -->

        <!-- <v-list-group
          prepend-icon="mdi-list"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title class="text-left">Otras Notificaciones</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in otrasNotificaciones"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group> -->

        <!-- <v-list-item
          v-for="(opcion, i) in oficialiaCatalogo"
          :to="opcion.link"
          :key="opcion.text"
          link
        >
          <v-list-item-title>{{ opcion.text }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon>{{ opcion.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item> -->

      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" block color="grey darken-3 white--text">
            <v-icon>mdi-lock</v-icon> Salir</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>

    <v-card class="overflow-hidden">
      <v-app-bar
        clipped-left
        app
        height="160%"
        color="#FFFFFF"
        src="@/assets/NOTIFICACIONESWEB.svg"
      >
        <v-app-bar-nav-icon
          v-if="isLoggedIn"
          @click.stop="drawer = !drawer"
          style="color:white;opacity: 0.7;background-color: black"
        />
        <v-spacer />
        <v-btn icon v-if="isLoggedIn" @click="logout" style="color:white;opacity: 0.7;background-color: black;">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-app-bar>
    </v-card>

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer padless>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>STJ</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    source: String
  },
  data: () => ({
    dialog: false,
    drawer: null,
    suparAdminCatalogo: [
      { icon: "mdi-account-card-details", text: "Validar Cédula", link: "/oficialia" },
      { icon: "mdi-account-group", text: "Partes", link: "/buscar-partes" },
      { icon: "mdi-folder", text: "Tocas", link: "/tocas" },
      { icon: "mdi-account", text: "Usuarios", link: "/users" },
      { icon: "mdi-account-question", text: "Roles", link: "/roles" },
      { icon: "mdi-chart-bar-stacked", text: "Estadísticas", link: "/dashboard" }
    ],
    oficialiaCatalogo: [
      // { icon: "mdi-account-card-details", text: "Validar Cédula", link: "/oficialia" },
      { icon: "mdi-account-group", text: "Partes", link: "/buscar-partes" }
      //{ icon: "mdi-account-question", text: "Roles", link: "/roles" }
    ],
    adminCatalogo: [
      // { icon: "mdi-account-card-details", text: "Validar Cédula", link: "/oficialia" },
      { icon: "mdi-account-group", text: "Partes", link: "/buscar-partes" },
      { icon: "mdi-folder", text: "Tocas", link: "/tocas" }
    ],
    notificadorCatalogo: [
      { icon: "mdi-folder", text: "Tocas", link: "/tocas" }
    ],
    otrasNotificaciones: [
      { icon: "mdi-account-card-details", text: "Parte sin Validar", link: "/partesinvalidar" },
      // { icon: "mdi-account-card-details", text: "Buscar Partes", link: "/buscar-partes" }
    ],
    // adminCatalogo: [
    //   //{ icon: "mdi-account-group", text: "Validar Cédula", link: "/oficialia" },
    //   {
    //     icon: "mdi-account-group",
    //     text: "Partes",
    //     link: "/partes",
    //     permissions: ['superadmin','admin']
    //   },
    //   {
    //     icon: "mdi-folder",
    //     text: "Tocas",
    //     link: "/tocas",
    //     permissions: ['superadmin','admin','notificador'],
    //     },
    //   {
    //     icon: "mdi-account",
    //     text: "Usuarios",
    //     link: "/users",
    //     permissions: ['superadmin']
    //   },
    //   {
    //     icon: "mdi-account-question",
    //     text: "Roles",
    //     link: "/roles",
    //     permissions: ['superadmin']
    //     }
    // ],
    // capturistaCatalogo: [
    //   { icon: "mdi-account-details", text: "Cédulas", link: "/cedulas" }
    // ]

  }),
  computed: {
    ...mapGetters(["roleUser", "isLoggedIn", "currentUser"])
  },
  methods: {
    logout() {
      this.$store
        .dispatch("LOGOUT")
        .then(() => {
          this.$swal({
            title: "Ha cerrado Sesión",
            icon: "success",
            timer: 1000
          }).then(() => {

          });
            this.$router.go('/');
          // this.$router.push("/");
        })
        .catch(error => {
          this.$swal({
            title: "Error",
            text: "No se pudo Cerrar la Sesión Correctamente",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
    }
  }
};
</script>
